/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ZabbixConfiguration extends models.ZabbixConfigurationBase {
    getFixupPrototypeFunction() { return ZabbixConfiguration.fixupPrototype; }

    static newInstance(model: Partial<ZabbixConfiguration>): ZabbixConfiguration {
        let obj = Object.assign(new ZabbixConfiguration(), model);
        ZabbixConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ZabbixConfiguration>): ZabbixConfiguration {
        if (!model) return null;
        return ZabbixConfiguration.newInstance(<ZabbixConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ZabbixConfiguration) {
        if (!obj) return;

        models.ZabbixConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ZabbixConfiguration): boolean {
        if (models.ZabbixConfigurationBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ZabbixConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.item) {
            models.ZabbixElement.fixupPrototype(this.item);
        }
        if (this.trigger) {
            models.ZabbixTriggerComponent.fixupPrototype(this.trigger);
        }
    }

    /**
     * Corestack resource type
     */
    resource_type: string;

    item: models.ZabbixElement;

    trigger: models.ZabbixTriggerComponent;

    /**
     * Cloud management action for Zabbix
     */
    cloud_management_action: string;

    /**
     * Execution types in Zabbix Configuration
     */
    execution_type: models.ZabbixExecutionType;

}
